<template>
  <el-container class="container">
    <el-divider content-position="left">任务清单列表</el-divider>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- 任务列表 开始-->
      <el-tab-pane :label="labelName" name="first">
        <!-- 搜索 -->
        <el-row style="margin-bottom: 0.3rem">
          <el-col :span="4">
            <el-cascader
              v-model="searchArr.publisher"
              placeholder="请选择发布人"
              :options="adminUsers"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
          <el-col :span="4">
            <el-cascader
              v-model="searchArr.receiver"
              placeholder="请选择接收人"
              :options="adminUsers"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
          <el-col :span="5">
            <el-date-picker
              v-model="searchArr.publish_at"
              type="date"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择发布日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="11" style="text-align: right;">
            <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
            <el-button type="danger" size="mini" @click="handleCloseSearch">清除</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.3rem;">
          <el-col style="text-align: left;">
            <el-button type="primary" size="mini" @click="handleAdd">新建任务</el-button>
            <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
          </el-col>
        </el-row>
        <el-main class="main-style">
          <el-table
          v-if="!tableLoading"
            height="calc(100vh - 390px)"
            :data="pageData"
            size="mini"
            border
            style="width: 100%"
            v-cloak
          >
            <el-table-column label="任务标题" width="120" fixed>
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.title" placement="top">
                  <!-- <span class="hide-style">{{ scope.row.title }}</span> -->
                  <el-link class="hide-style" type="primary" :underline="false" @click="handleOpenFeedBackLists(scope.row)"
                    >{{ scope.row.title }}
                  </el-link>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="任务内容" width="250">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.content" placement="top">
                  <span class="hide-style">{{ scope.row.content }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="企业数量" width="80">
              <template slot-scope="scope">
                {{ scope.row.company.length }}
              </template>
            </el-table-column>
            <el-table-column label="任务状态" width="100">
              <template slot-scope="scope">
                <el-tag type="success">{{ scope.row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="发布人" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.issuer.username }}</span>
              </template>
            </el-table-column>
            <el-table-column label="发布时间" width="120">
              <template slot-scope="scope">
                <date-formatter :date-value="scope.row.publish_at"></date-formatter>
              </template>
            </el-table-column>
            <el-table-column label="截止时间" width="120">
              <template slot-scope="scope">
                <date-formatter :date-value="scope.row.end_time"></date-formatter>
              </template>
            </el-table-column>
            <el-table-column label="接收人" width="auto">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.receive_user" placement="top">
                  <span class="hide-style">{{ scope.row.receive_user }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="接收角色" width="100">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.receiveroler_str" placement="top">
                  <span class="hide-style">{{ scope.row.receiveroler_str }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="handleLookOpen(scope.row, 1)"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  @click="handleDelete(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="loading-placeholder">加载中，请稍后...</div>
        </el-main>
      </el-tab-pane>
      <!-- 任务列表 结束-->
      <!-- 任务反馈 开始-->
      <el-tab-pane :label="labelSecond" name="second">
        <!-- 搜索 -->
        <el-row style="margin-bottom: 0.3rem">
          <el-col :span="4">
            <el-select
              v-model="searchFeedback.company_id"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司名称筛选公司"
              size="mini"
              clearable
              :remote-method="searchRemoteCompanyMethod"
              :loading="searchLoading"
            >
              <el-option
                v-for="searchCompany in searchCompanies"
                :key="searchCompany.id"
                :label="searchCompany.company_name"
                :value="searchCompany.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" >
            <el-cascader
              v-model="searchFeedback.publisher"
              placeholder="请选择发布人"
              :options="adminUsers"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
          <el-col :span="4">
            <el-date-picker
              style="width: 90%"
              v-model="searchFeedback.publish_at"
              type="date"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择发布日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="4" >
            <el-date-picker
              style="width: 90%"
              v-model="searchFeedback.receive_at"
              type="date"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择接收日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="4" >
            <el-date-picker
            style="width: 90%"
              v-model="searchFeedback.end_time"
              type="date"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择截止日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="4" style="text-align: right;">
            <el-button type="primary" size="mini" @click="handleTaskFeedbackSearch"
              >查询</el-button
            >
            <el-button type="danger" size="mini" @click="handleTaskFeedbackCloseSearch"
              >清除</el-button
            >
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.3rem;">
            <el-col style="text-align: left;">
            <!-- <el-button type="primary" size="mini" @click="handleTaskFeedbackExport"
              >导出</el-button
            > -->
            <el-button v-if="selectValues.length > 0" type="primary" size="mini" @click="handleTaskFeedbackAccept(selectValues)"
              >接收</el-button
            >
          </el-col>
        </el-row>
        <el-main class="main-style">
          <el-table
            height="calc(100vh - 350px)"
            :data="pageDataF"
            size="mini"
            border
            style="width: 100%"
            v-cloak
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column label="公司名称" width="200" fixed>
              <template slot-scope="scope"> 
                <el-tooltip :content="scope.row.company.company_name" placement="top">
                  <span class="hide-style">{{ scope.row.company.company_name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="任务标题" width="120">
              <template slot-scope="scope"> 
                <el-tooltip :content="scope.row.title" placement="top">
                  <el-link class="hide-style" type="primary" :underline="false" @click="handleLookOpen(scope.row, 2)"
                    >{{ scope.row.title }}
                  </el-link>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="任务内容" width="auto">
              <template slot-scope="scope"> 
                <el-tooltip :content="scope.row.content" placement="top">
                  <span class="hide-style">{{ scope.row.content }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="任务状态" width="100">
              <template slot-scope="scope"> 
                <el-tag v-if="scope.row.status === 0" type="success">待接收</el-tag>
                <el-tag v-else-if="scope.row.status === 1" type="info">待反馈</el-tag>
                <el-tag v-else-if="scope.row.status === 2" type="danger">已暂停</el-tag>
                <el-tag v-else-if="scope.row.status === 3" type="warning">已完成</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="暂停原因" width="150">
              <template slot-scope="scope"> 
                <el-tooltip :content="scope.row.pause_reason" placement="top">
                  <span class="hide-style">{{ scope.row.pause_reason }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="发布人" width="120">
              <template slot-scope="scope">
                <span class="hide-style">{{ scope.row.com_puber.issuer.username }}</span>
              </template>
            </el-table-column>
            <el-table-column label="发布日期" width="120">
              <template slot-scope="scope">
                <date-formatter :date-value="scope.row.publish_at"></date-formatter>
              </template>
            </el-table-column>
            <el-table-column label="截止日期" width="120">
              <template slot-scope="scope">
                <date-formatter :date-value="scope.row.end_time"></date-formatter>
              </template>
            </el-table-column>
            <el-table-column label="接收人" width="120">
              <template slot-scope="scope">
                  <span class="hide-style">{{ scope.row.receiver && scope.row.receiver.adminuser ? scope.row.receiver.adminuser.username : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="接收日期" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.receiver">
                  <date-formatter :date-value="scope.row.receiver.receiver_at"></date-formatter>
                </span>
                <span v-else></span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="handleLookOpen(scope.row, 2)"
                  v-if="scope.row.status === 0"
                  >接收</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  @click="handleFeedback(scope.row.id)"
                  v-if="scope.row.status === 1 || scope.row.status === 2"
                  >反馈</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  @click="handleLookOpen(scope.row, 2)"
                  v-if="scope.row.status === 3"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-tab-pane>
      <!-- 任务反馈 结束-->
    </el-tabs>

    <el-footer class="footer-style">
      <el-pagination
        class="tr mt-10"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :hide-on-single-page="false"
        :current-page.sync="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageOption.total"
        background
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      title="新建任务"
      :visible.sync="addFormDrawer"
      direction="rtl"
      :before-close="handleCloseDrawer"
      size="50%"
    >
      <div class="m-tabs-content">
        <el-steps
          :active="activeStep"
          finish-status="success"
          align-center
          class="step-style"
        >
          <el-step title="Step 1"></el-step>
          <el-step title="Step 2"></el-step>
          <el-step title="Step 3"></el-step>
        </el-steps>

        <el-form
          v-if="activeStep === 0"
          ref="step1Form"
          :rules="step1FormRules"
          :model="step1Form"
          label-width="100px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务标题" prop="title">
                <el-input
                  size="mini"
                  placeholder="请输入任务标题"
                  v-model="step1Form.title"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="任务内容" prop="content">
                <el-input
                  size="mini"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入任务内容"
                  v-model="step1Form.content"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="截止时间" prop="end_time">
                <el-date-picker
                  size="mini"
                  clearable
                  v-model="step1Form.end_time"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="选择截止时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-form
          v-if="activeStep === 1"
          ref="step2Form"
          :rules="step2FormRules"
          :model="step2Form"
          label-width="100px"
        >
          <el-row>
            <el-col>
              <el-form-item label="企业名单" prop="company_list">
                <el-input
                  size="mini"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 100 }"
                  placeholder="请将企业名单复制到此处，用回车键隔开"
                  v-model="step2Form.company_list"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上传附件" prop="file_list">
                <el-upload
                  multiple
                  :limit="limitFile"
                  ref="upload_attachment"
                  :action="actionHost + '/api/admin/task_lists/upload'"
                  :headers="headers"
                  :accept="acceptFileTypes"
                  :file-list="fileLists"
                  :on-success="handleUploadSuccess"
                  :on-change="handleUploadChange"
                  :on-remove="handleRemove"
                >
                  <el-link slot="trigger" type="primary">点击上传</el-link>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-form
          v-if="activeStep === 2"
          ref="step3Form"
          :model="step3Form"
          label-width="100px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="接收人">
                <el-cascader
                  v-model="step3Form.receiver"
                  placeholder="请选择接收人"
                  :options="adminUsers"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接收角色">
                <el-select
                  @click.native="getRoles"
                  v-model="step3Form.role"
                  placeholder="请选择接收角色"
                  clearable
                  multiple
                  filterable
                  size="mini"
                >
                  <el-option
                    v-for="(item, index) in roles"
                    :key="index"
                    :label="item.role_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="margin-top: 20px; text-align: center">
          <el-button size="small" :disabled="activeStep === 0" @click="prevStep"
            >上一步</el-button
          >
          <el-button
            size="small"
            type="primary"
            v-if="activeStep !== steps.length - 1"
            @click="nextStep"
            >下一步</el-button
          >
          <el-button
            size="small"
            v-else
            type="primary"
            @click="handleConfirm"
            >发布</el-button
          >
        </div>
      </div>
    </el-drawer>

    <!-- 任务详情 -->
    <el-dialog :visible.sync="taskDetailDialog" title="任务详情" width="500" :modal="false" :lock-scroll="false" :modal-append-to-body="false" v-dialpad-drag>
      <el-row class="detail-row">
        <el-col :span="3">任务标题：</el-col>
        <el-col :span="21">{{ taskDetail.title }}</el-col>
      </el-row>
      <el-row class="detail-row">
        <el-col :span="3">发布人：</el-col>
        <el-col :span="21">{{ taskDetail.publisher }}</el-col>
      </el-row>
      <el-row class="detail-row" v-if="taskDetail.receive_user !== ''">
        <el-col :span="3">接收人：</el-col>
        <el-col :span="21">{{ taskDetail.receive_user }}</el-col>
      </el-row>
      <el-row class="detail-row" v-if="taskDetail.receiveroler_str !== ''">
        <el-col :span="3">接收角色：</el-col>
        <el-col :span="21">{{ taskDetail.receiveroler_str }}</el-col>
      </el-row>
      <el-row class="detail-row">
        <el-col :span="3">任务内容：</el-col>
        <el-col :span="21">{{ taskDetail.content }}</el-col>
      </el-row>
      <el-row class="detail-row">
        <el-col :span="3">任务状态：</el-col>
        <el-col :span="20" v-if="taskDetail.type === 1">
          <el-tag size="mini" type="success">{{ taskDetail.status }}</el-tag>
        </el-col>
        <el-col :span="20" v-if="taskDetail.type === 2">
          <el-tag v-if="taskDetail.status === 0" size="mini" type="success">待接收</el-tag>
          <el-tag v-else-if="taskDetail.status === 1" size="mini" type="info">待反馈</el-tag>
          <el-tag v-else-if="taskDetail.status === 2" size="mini" type="danger">已暂停</el-tag>
          <el-tag v-else-if="taskDetail.status === 3" size="mini" type="warning">已完成</el-tag>
        </el-col>
      </el-row>
      <el-row class="detail-row" v-if="taskDetail.type === 2 && taskDetail.status === 2">
        <el-col :span="3">暂停原因：</el-col>
        <el-col :span="21">{{ taskDetail.pause_reason }}</el-col>
      </el-row>
      <el-row class="detail-row">
        <el-col :span="3">发布时间：</el-col>
        <el-col :span="21">
          <date-formatter :date-value="taskDetail.publish_at"></date-formatter>
        </el-col>
      </el-row>
      <el-row class="detail-row">
        <el-col :span="3">截止时间：</el-col>
        <el-col :span="21">
          <date-formatter :date-value="taskDetail.end_time"></date-formatter>
        </el-col>
      </el-row>
      <el-row class="detail-row">
        <el-col :span="3">企业名单：</el-col>
        <el-col :span="21">
          <span v-html="taskDetail.company_list"></span>
        </el-col>
      </el-row>
      <el-row class="detail-row">
        <el-col :span="3">上传附件：</el-col>
        <el-col :span="21">
          <span v-html="taskDetail.file_list"></span>
        </el-col>
      </el-row>
      <el-row style="text-align: right;" v-if="taskDetail.type === 2">
        <el-col>
          <el-button
            type="primary"
            size="small"
            @click="handleTaskFeedbackSingleAccept(taskDetail.id)"
            v-if="taskDetail.status === 0"
            >接收</el-button
          >
          <!-- <el-button
            type="primary"
            size="small"
            @click="handleFeedback(taskDetail.id)"
            v-if="taskDetail.status === 1 || taskDetail.status === 2"
            >反馈</el-button
          > -->
          <el-button
            type="warning"
            size="small"
            @click="handleCancel"
            >关闭</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 任务反馈 -->
    <el-dialog :visible.sync="feedbackVisible" title="任务反馈" width="500" :modal="false" :lock-scroll="false" :modal-append-to-body="false" v-dialpad-drag>
      <el-row class="detail-row">
        <el-col :span="21">
          <el-form
            :model="feedbackForm"
            ref="feedbackForm"
            label-width="100px"
            size="mini"
          >
            <el-form-item label="任务状态" prop="task_status" style="margin-bottom: 0.4rem;">
              <el-radio-group v-model="feedbackForm.task_status" size="mini">
                <el-radio label="3" border>已完成</el-radio>
                <el-radio label="2" border>暂停</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="暂停原因" prop="pause_reason" v-if="feedbackForm.task_status === '2'">
              <el-input
                size="mini"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入暂停原因"
                v-model="feedbackForm.pause_reason"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row style="text-align: right;">
        <el-col>
          <el-button
            type="primary"
            size="small"
            @click="handleConfirmFeedback"
            >确定</el-button
          >
          <el-button
            type="warning"
            size="small"
            @click="handleCancelFeedback"
            >关闭</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog :visible.sync="batchFeedbackVisible" title="批量反馈" width="500" :modal="false" :lock-scroll="false" :modal-append-to-body="false" v-dialpad-drag>
      <el-row class="detail-row">
        <el-col :span="21">
          <el-form
            :model="batchFeedbackForm"
            ref="batchFeedbackForm"
            label-width="100px"
            size="mini"
          >
            <el-form-item label="任务状态" prop="task_status" style="margin-bottom: 0.4rem;">
              <el-radio-group v-model="batchFeedbackForm.task_status" size="mini">
                <el-radio label="3" border>已完成</el-radio>
                <el-radio label="2" border :disabled="true">暂停</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row style="text-align: right;">
        <el-col>
          <el-button
            type="primary"
            size="small"
            @click="handleConfirmBatchFeedback"
            >确定</el-button
          >
          <el-button
            type="warning"
            size="small"
            @click="handleCancelBatchFeedback"
            >关闭</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 不存在企业名称提示 -->
    <el-dialog :visible.sync="validatorTip" title="以下企业未在系统中检测到，分别是：" width="40%" :modal="false" :lock-scroll="false" :modal-append-to-body="false" v-dialpad-drag>
      <el-row class="detail-row">
        <el-col :span="24">
          <p style="line-height: 0.4rem;" v-html="notExistCom"></p>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="display: flex;justify-content: space-between;align-items: center;">
          <span style="text-align: left;font-size: .34rem;color: #333;">请核实后进行任务发布！</span>
          <el-button
            style="text-align: right;"
            type="warning"
            size="small"
            @click="handleCloseTip"
            >关闭</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>

  </el-container>
</template>

<script>
import DateFormatter from "common/DateFormatter";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "TaskLists",
  components: {
    DateFormatter,
  },
  data() {
    return {
      tableLoading: true,
      activeName: "first",
      labelName: '任务列表',
      labelSecond: '',
      inputValue: '',
      pageData: [],
      pageDataF: [],
      adminUsers: [],
      roles: [],
      fileLists: [],
      needUrl: [],
      limitFile: 3,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      acceptFileTypes:
        "image/*,.doc,.docx,.xlsx,.zip,.xls,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      searchArr: {
        tab_label: "first",
        publisher: "",
        receiver: "",
        publish_at: "",
      },
      searchLoading: false,
      searchCompanies: [],
      searchFeedback: {
        tab_label: "second",
        company_id: "",
        publisher: "",
        publish_at: "",
        receive_at: "",
        end_time: '',
        task_id: ''
      },
      addFormDrawer: false,
      activeStep: 0,
      steps: ["Step 1", "Step 2", "Step 3"],
      step1FormRules: {
        title: [{ required: true, message: '任务标题不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '任务内容不能为空', trigger: 'blur' }],
      },
      step2FormRules: {
        company_list: [{ required: true, message: '企业名单不能为空', trigger: 'blur' }]
      },
      validatorTip: false,
      notExistCom: '',
      step1Form: {
        title: "",
        content: "",
        end_time: "",
      },
      step2Form: {
        company_list: "",
      },
      step3Form: {
        receiver: "",
        role: "",
      },
      taskDetailDialog: false,
      taskDetail: {},
      selectValues: [],
      feedbackVisible: false,
      feedbackForm: {
        task_status: "",
        pause_reason: ""
      },
      batchFeedbackVisible: false,
      batchFeedbackForm: {
        ids: [],
        task_status: "3"
      },
    };
  },
  computed: {
    // isStepValid() {
    //   if (this.activeStep === 0) {
    //     return this.$refs.step1Form ? this.$refs.step1Form.validate() : false;
    //   } else if (this.activeStep === 1) {
    //     return this.$refs.step2Form ? this.$refs.step2Form.validate() : false;
    //   } else if (this.activeStep === 2) {
    //     return this.$refs.step3Form ? this.$refs.step3Form.validate() : false;
    //   } else {
    //     return false;
    //   }
    // },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    searchTaskFeedbackStr: function () {
      let str = "";
      for (let key in this.searchFeedback) {
        str += "&" + key + "=" + this.searchFeedback[key];
      }
      return str;
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    // handleSearchCom(queryString, cb) {
    //   var suggestions = this.suggestions;
    //   var results = queryString ? suggestions.filter(this.createFilter(queryString)) : suggestions;
    //   cb(results);
    // },
    // createFilter(queryString) {
    //   return (restaurant) => {
    //     return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //   };
    // },
    // handleSelectCom(item) {
    //   this.inputValue = '';
    //   this.step2Form.company_list += `${item.value}\n`;
    // },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    handleConfirm() {
      const formData = { ...this.step1Form, ...this.step2Form, ...this.step3Form};
      this.$axios.post("api/admin/task_lists/store", {
        formData: formData,
        fileData: this.needUrl
      }).then((res) => {
        let { data } = res;
        if (data.code === 1) {
          this.addFormDrawer = false;
          this.$message.success(data.msg);
          this.activeStep = 0;
          this.getPageData();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 任务详情
    handleLookOpen(row, type) {
        this.taskDetail.type = type;
        this.taskDetail.title = row.title;
        this.taskDetail.content = row.content;
        this.taskDetail.publish_at = row.publish_at;
        this.taskDetail.end_time = row.end_time;
        this.taskDetail.file_list = row.file.length > 0 ? row.file.map(item => `${item.name} —— <a href="${item.url}">点击下载</a>`).join('<br>') : '';
      if (type === 1) {  // 任务列表查看
        this.taskDetail.receive_user = row.receive_user;
        this.taskDetail.receiveroler_str = row.receiveroler_str;
        this.taskDetail.status = row.status;
        this.taskDetail.publisher = row.issuer.username;
        this.taskDetail.company_list = row.company.map(item => `<p>${item.company_name}</p>`).join('<br>');
      } else if (type === 2) {  // 任务反馈列表查看
        this.taskDetail.id = row.id;
        this.taskDetail.status = row.status;
        this.taskDetail.receive_user = row.receiver && row.receiver.adminuser ? row.receiver.adminuser.username : '';
        this.taskDetail.receiveroler_str = '';
        this.taskDetail.pause_reason = row.pause_reason;
        this.taskDetail.publisher = row.com_puber.issuer.username;
        this.taskDetail.company_list = row.company.company_name;
      }

      this.taskDetailDialog = true;
    },
    handleTaskFeedbackSingleAccept(value) {
      this.taskDetailDialog = false;
      var ids = [value];
      this.$axios
        .post("/api/admin/task_feedback_lists", {ids: ids})
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.taskDetailDialog = false;
            this.feedbackVisible = true;
            this.feedbackForm.id = ids[0];
            this.getPageData();
          }
      });
    },
    handleTaskFeedbackAccept(values) {
      var ids = values.map(item => item.id);
      this.$axios
        .post("/api/admin/task_feedback_lists", {ids: ids})
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.batchFeedbackVisible = true;
            this.batchFeedbackForm.ids = ids;
            this.getPageData();
          }
      });
    },
    handleFeedback(id) {
      this.feedbackVisible = true;
      this.feedbackForm.id = id;
    },
    handleConfirmFeedback() {
      if (this.feedbackForm.task_status === '2' && !this.feedbackForm.pause_reason) {
        this.$message.success('当暂停时，请填写暂停原因！');
        return false;
      }
      this.$axios
        .post("/api/admin/task_feedback_confirm", {form: this.feedbackForm})
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.feedbackVisible = false;
            this.$refs.feedbackForm.resetFields();
            this.getPageData();
          }
      });
    },
    handleConfirmBatchFeedback() {
      this.$axios
        .post("/api/admin/task_feedback_confirm_batch", {form: this.batchFeedbackForm})
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.batchFeedbackVisible = false;
            this.$refs.batchFeedbackForm.resetFields();
            this.getPageData();
          }
      });
    },
    handleCancelFeedback() {
      this.feedbackVisible = false;
      this.$refs.feedbackForm.resetFields();
    },
    handleCancelBatchFeedback() {
      this.batchFeedbackVisible = false;
      this.$refs.batchFeedbackForm.resetFields();
    },
    handleCancel() {
      this.taskDetailDialog = false;
    },
    handleDelete(id) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.$axios.post("/api/admin/task_lists/delete", { id }).then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.getPageData();
          } else {
            this.$message.error(data.msg);
          }
        });
      })
      .catch(() => {});
    },
    beforeUpload(file) {
      const allowedExtensions = this.acceptFileTypes.split(",");
      const fileType = file.type;
      const fileName = file.name;

      // 判断文件类型是否在接受的类型列表中
      if (!this.isFileTypeAllowed(fileType, allowedExtensions)) {
        this.$message.error("只能上传指定类型的文件");
        return false;
      }

      // 判断文件扩展名是否在接受的类型列表中
      const extension = fileName.split(".").pop().toLowerCase();
      if (!this.isFileTypeAllowed(extension, allowedExtensions)) {
        this.$message.error("只能上传指定类型的文件");
        return false;
      }
      return true;
    },
    isFileTypeAllowed(fileType, allowedExtensions) {
      // 判断文件类型是否在接受的类型列表中
      for (const type of allowedExtensions) {
        if (type === fileType) {
          return true;
        }
      }
      return false;
    },
    handleUploadSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
    },
    handleUploadChange (res, file) {
      this.fileLists = file
    },
    handleRemove (file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileLists = fileList
    },
    handleAdd() {
      this.addFormDrawer = true;
      this.clearFormData();
    },
    getPageData() {
      let searchParam = this.searchStr; // 默认使用 this.searchStr
      if (this.activeName === "second") {
        searchParam = this.searchTaskFeedbackStr; // 使用 this.searchTaskFeedbackStr
      }
      this.$axios
        .get(
          "/api/admin/task_lists?page=" +
            this.pageOption.currentPage +
            "&pageSize=" +
            this.pageOption.pageSize +
            searchParam
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            if (this.activeName === "first") {
              this.pageData = data.data.data.data;
            } else {
              this.pageDataF = data.data.data.data;
            }
            this.pageOption.total = data.data.data.total;
          }
        }).finally(() => {
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageData();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageData();
    },
    handleExport() {
      this.$axios
        .post(
          "api/admin/task_lists/export",
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "任务列表清单.csv";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    handleTaskFeedbackExport() {
      this.$axios
        .post(
          "api/admin/task_feedback_lists/export",
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "任务反馈清单.csv";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    handleSearch() {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    handleTaskFeedbackSearch() {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    handleCloseSearch() {
      this.searchArr.publisher = "";
      this.searchArr.receiver = "";
      this.searchArr.publish_at = "";
      this.getPageData();
    },
    handleTaskFeedbackCloseSearch() {
      this.searchFeedback.company_id = "";
      this.searchFeedback.publisher = "";
      this.searchFeedback.publish_at = "";
      this.searchFeedback.receive_at = "";
      this.searchFeedback.end_time = '';
      this.getPageData();
    },
    handleSelectionChange(val) {
      this.selectValues = val;
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    async getAdminUsers() {
      try {
        const res = await this.$axios.get("/api/admin/user/branch");
        const { data } = res;
        if (data.code === 1) {
          this.adminUsers = data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getRoles() {
      this.$axios.get("/api/admin/roles").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.roles = data.data.roles;
        }
      });
    },
    clearFormData() {
      this.step1Form.title = "";
      this.step1Form.content = "";
      this.step1Form.end_time = "";
      this.step2Form.company_list = "";
      this.fileLists = [];
      this.step3Form.receiver = "";
      this.step3Form.role = '';
    },
    handleCloseDrawer(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.step1Form.title = "";
          this.step1Form.content = "";
          this.step1Form.end_time = "";
          this.step2Form.company_list = "";
          this.step3Form.receiver = "";
          this.step3Form.role = '';
          this.activeStep = 0;
          this.addFormDrawer = false;
          done();
        })
        .catch((_) => {});
    },
    handleOpenFeedBackLists(row) {
      this.labelSecond = '任务反馈';
      this.activeName = "second";
      this.pageOption.currentPage = 1;
      this.searchFeedback.task_id = row.id;
      this.getPageData();
    },
    handleClick(tab, event) {
      if (parseInt(tab.index) === 0) {
        this.activeName = "first";
        this.labelSecond = '';
        this.searchFeedback.task_id = '';
        this.pageOption.currentPage = 1;
        this.getPageData();
      } 
      // else if (parseInt(tab.index) === 1) {
      //   this.activeName = "second";
      //   this.pageOption.currentPage = 1;
      //   this.getPageData();
      // }
    },
    validatorCompanyList() {
      return this.$axios.post('/api/admin/task_list/validator_company', {company_list: this.step2Form.company_list})
      .then((res) => {
        const { data } = res;
        if (data.code === 0 && data.data.length > 0) {
          this.validatorTip = true;
          this.notExistCom = data.data.map(value => `${value}<br>`).join('');
          return true;
        } else {
          return false;
        }
      }).catch((error) => {
        console.error('Error validating company list:', error);
        return false;
      });
    },
    nextStep() {
      if (this.activeStep === 0) {
        this.$refs.step1Form.validate((valid) => {
          if (valid) {
            this.activeStep++;
          } else {
            this.$message.error('请先完成当前步骤下的必填项！');
          }
        });
      } else if (this.activeStep === 1) {
        this.$refs.step2Form.validate((valid) => {
          if (valid) {
            // 验证企业名单是否存在不符合要求
            this.validatorCompanyList().then((resTip) => {
              if (resTip) {
                this.$message.error('请处理异常企业名称信息再下一步！');
              } else {
                this.activeStep++;
              }
            });
          } else {
            this.$message.error('请先完成当前步骤下的必填项！');
          }
        });
      } else if (this.activeStep === 2) {
        this.$refs.step3Form.validate((valid) => {
          if (valid) {
            // 生成预览

            this.activeStep++;
          } else {
            this.$message.error('请先完成当前步骤下的必填项！');
          }
        });
      }
    },
    handleCloseTip() {
      this.validatorTip = false;
      this.notExistCom = '';
    },
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep--;
      }
    },
  },
  mounted() {
    this.getPageData();
    this.getAdminUsers();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.tab-none-style{
  display: none;
}

.container {
  .el-drawer__wrapper >>> .el-drawer {
    overflow-y: auto !important;
  }
}

.icon-class {
  width: 16px;
  margin-bottom: 0.06rem;
  margin-right: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.hide-style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0;
  border: none;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.el-drawer .el-form-item {
  margin-bottom: 0.3rem !important;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.m-tabs-content {
  overflow-y auto;
  padding: 0px 0.2rem 0px 0.4rem;
}

.step-style{
  margin-bottom: 0.4rem;
}

.detail-row{
  margin-bottom: 0.6rem;
}

.loading-placeholder {
  text-align: center;
  padding: 20px;
}

.container {
  marginLeft();
  max-height: 100vh;
  .tr {
    text-align: right;
  }

  .mt-10 {
    margin-top: 0.2rem;
  }

  .PayerContent >>> .el-link--inner {
    font-size: 12px !important;
  }
  
  .main-style {
    padding: 0px !important;
    overflow-y: auto;
  }

  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/task_lists/TaskLists.vue